var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9474 10L1.68421 9.99286C0.757325 9.99287 0.00463443 9.35762 0 8.57143V1.42857C0.00463443 0.642384 0.757325 0.00713324 1.68421 0.00714307L10.9474 1.05237e-07C11.4924 -0.000177076 12.0039 0.223388 12.32 0.6L16 5L12.32 9.4C12.0039 9.77661 11.4924 10.0002 10.9474 10ZM1.68421 1.42857V8.57143H10.9474L13.9368 5L10.9474 1.42857H1.68421Z",
    fill: "#5B6673"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.b3769d57956b450d6b4b2f121f3fcc11.svg";
export { ForwardRef as ReactComponent };